import React, { useEffect, useRef } from 'react';
import { logComponentAnalyticsEvent } from '../utils/componentAnalytics';

export default function ComponentAnalyticsTracker({
                                                     comp,
                                                     muulti,
                                                     surface = 'public',
                                                     trackImpression = true,
                                                     trackView = false,
                                                     className = '',
                                                     style,
                                                     id,
                                                     children,
                                                 }) {
    const ref = useRef(null);

    useEffect(() => {
        if (!trackView) return;
        logComponentAnalyticsEvent({ eventType: 'view', comp, muulti, surface });
    }, [comp, muulti, surface, trackView]);

    useEffect(() => {
        if (!trackImpression) return undefined;
        const node = ref.current;
        if (!node) return undefined;

        if (typeof IntersectionObserver === 'undefined') {
            logComponentAnalyticsEvent({ eventType: 'impression', comp, muulti, surface });
            return undefined;
        }

        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (!entry?.isIntersecting) return;
            logComponentAnalyticsEvent({ eventType: 'impression', comp, muulti, surface });
            observer.disconnect();
        }, { threshold: 0.35 });

        observer.observe(node);
        return () => observer.disconnect();
    }, [comp, muulti, surface, trackImpression]);

    const handleInteraction = (event) => {
        if (event?.target?.closest?.('.component-analytics-summary')) return;
        logComponentAnalyticsEvent({ eventType: 'interaction', comp, muulti, surface });
    };

    return (
        <div
            ref={ref}
            id={id}
            className={className}
            style={style}
            onClickCapture={handleInteraction}
            onSubmitCapture={handleInteraction}
            onPlayCapture={handleInteraction}
        >
            {children}
        </div>
    );
}
